import axios from 'axios';
import { type DBLogCreate } from '../types/log';
import type { DebugLevel } from '../../_configs/types';

export const createLog = (data: DBLogCreate, debug: DebugLevel) =>
    axios({
        debug,
        noLogging: true,
        method: 'put',
        url: 'https://web-servlets.autohaus-digital.de/logs',
        data: data,
    });
